import { Plus, Save } from 'lucide-react'

const CameraModalFooter = ({
    isQuickAdd,
    isEditing,
    loading,
    quickAddData,
    formData,
    handleChange,
    onClose
}) => {
    return (
        <div className="flex items-center justify-between p-6 bg-gray-50 border-t border-gray-200">
            <div className="flex items-center space-x-4">
                {!isQuickAdd && (
                    <label className="flex items-center space-x-2">
                        <input
                            type="checkbox"
                            name="isActive"
                            checked={formData.isActive}
                            onChange={handleChange}
                            className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                        />
                        <span className="text-sm text-gray-700">Camera Active</span>
                    </label>
                )}
            </div>
            <div className="flex items-center space-x-3">
                <button
                    type="button"
                    onClick={onClose}
                    className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    disabled={loading}
                    className={`px-6 py-2 text-white rounded-lg transition-colors flex items-center space-x-2 ${
                        isQuickAdd 
                            ? 'bg-green-600 hover:bg-green-700 disabled:bg-gray-400' 
                            : 'bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-400'
                    }`}
                >
                    {loading ? (
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    ) : isQuickAdd ? (
                        <Plus className="h-4 w-4" />
                    ) : (
                        <Save className="h-4 w-4" />
                    )}
                    <span>
                        {loading ? 'Creating...' : isQuickAdd ? `Create ${quickAddData.cameraCount || 0} Cameras` : (isEditing ? 'Update Camera' : 'Create Camera')}
                    </span>
                </button>
            </div>
        </div>
    )
}

export default CameraModalFooter 